import {knowledgeInstructionsSectionsIds} from '../../util/uiconstants';
import {tiNormalizer} from '../../util/utils';

export const mapInstructions = (item, isTask) => {
	let newInstruction = {
		...tiNormalizer.genericProps(item),
		...tiNormalizer.documents(item),
		...tiNormalizer.scopes(item),
		...tiNormalizer.teams(item)
	};

	if (isTask) {
		newInstruction = {
			...newInstruction,
			...tiNormalizer.dueDate(item)
		};
	}

	return newInstruction;
};

const mapSections = ({
	sectionId: id,
	sectionName: label,
	isCustom,
	lastPublishDate,
	instructions,
	knowledgeInstructionSectionId
}) => {
	const isTask = knowledgeInstructionSectionId === knowledgeInstructionsSectionsIds.groupTasks;
	const newSection = {
		id,
		count: instructions.length,
		lastPublishDate
	};

	const normalizedInstructions = instructions.map((item) => mapInstructions(item, isTask));

	if (isTask) {
		newSection.tasks = normalizedInstructions;
	} else {
		newSection.label = label;
		newSection.isCustom = isCustom;
		newSection.instructions = normalizedInstructions;
		if (!isCustom) newSection.knowledgeInstructionSectionId = knowledgeInstructionSectionId;
	}

	return newSection;
};

const sortInstructions = (instructions) => [
	...tiNormalizer.filterSortKnowledge(instructions),
	...tiNormalizer.filterSortCustom(instructions, 'title')
];

const sortSections = (sections) => [
	...tiNormalizer.filterSortKnowledge(sections, 'knowledgeInstructionSectionId'),
	...tiNormalizer.filterSortCustom(sections, 'label')
];

export const sortAll = (sections, isTask = false) => {
	const withSortedInstructions = sections.map((item) => {
		const {instructions = null, tasks = null} = item;

		const newItem = {...item};

		if (isTask) newItem.tasks = sortInstructions(tasks);
		else newItem.instructions = sortInstructions(instructions);

		return newItem;
	});

	return isTask ? [...withSortedInstructions][0] : sortSections(withSortedInstructions);
};

export default (sections, isTask = false) => {
	const mappedSections = sections.map(mapSections);
	return sortAll(mappedSections, isTask);
};
